/**
 * Should there not be a projectionTabId, we assume this is the main window and use this
 * as the string key for the moveTo store.
 */
export const MAIN_WINDOW_ID: string = "main_window";
